import styled from 'styled-components';
import { BACKGROUND_PROPERTIES, HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS } from '../../TouchpointContainer';

export const BlockContainer = styled.div`
    display: flex;
    justify-content: center;

    ${BACKGROUND_PROPERTIES}
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
